import { useQuery } from '@tanstack/react-query';
import SettingsService from '../../services/SettingsService';

export const settingsKey = {
  all: 'settings',
  detail: () => [...settingsKey.all, 'detail'],
};

export function useSettings() {
  return useQuery({
    queryKey: settingsKey.detail(),
    queryFn: () => SettingsService.findAll(),
  });
}
